import { ACCREDITATION_BIO, ACCREDITATION_BIO_STATUS } from '../actions/accreditation';

const initialState = {
  bio: {
    accreditationIndex: null,
    accreditationActive: false,
    accreditationId: 'accreditation-template',
  },
  status: [],
};

export const accreditationReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case ACCREDITATION_BIO:
      return {
        ...state,
        bio: { ...state.bio, ...action.payload },
      };
    case ACCREDITATION_BIO_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
